<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head
        :searchConfig="tableData.searchConfig"
        @searchData="searchData"
        @deletePost="deletePost"
      />
    </template>
    <template>
      <Body
        ref="table"
        :headConfig="tableData.headConfig"
        :tableData="data.sendList"
        :selectable="selectable"
        @showMessage="showMessage"
        @deleteData="deleteDate"
        @select-change="selectChange"
        @sort-change="sortChange"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
    <template>
      <Drawer
        ref="drawer"
        :title="drawerData.title"
        :data="drawerData.data"
        :size="drawerData.size"
        :isLoading="drawerData.isLoading"
      />
    </template>
  </Layout>
</template>

<script>
import getSendPage from "@/api/getSendPage.js";
import deleteSendHistory from "@/api/deleteSendHistory.js";
import getComments from "@/api/getComments.js";
import deleteComments from "@/api/deleteComments.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import Drawer from "@/components/Drawer";
import requstData from "@/mixins/requstData.js";

export default {
  mixins: [requstData({ sendList: [], total: 10 })],
  components: {
    Layout,
    Head,
    Body,
    Foot,
    Drawer,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: true,
          selectProp: "createTime",
          key: "id",
          list: [
            { label: "详情", width: "65", type: "expand" },
            { label: "专页名称", prop: "pageName", width: "150" },
            { label: "贴文信息", prop: "content" },
            { label: "留言信息", prop: "leaveMessage" },
            { label: "类型", prop: "sendType", width: "80" },
            {
              label: "排文时间",
              prop: "sendTime",
              width: "180",
              sortable: "custom",
            },
            { label: "状态", prop: "status", width: "80" },
            { label: "创建者", prop: "userName", width: "180" },
            {
              label: "创建时间",
              prop: "createTime",
              width: "180",
              sortable: "custom",
            },
            {
              label: "操作",
              width: "200",
              operation: [
                {
                  type: 1,
                  label: "查看留言",
                  style: "primary",
                  listeners: "showMessage",
                  disabled: (data) => data.status == "2",
                },
                {
                  type: 2,
                  label: "删除",
                  style: "danger",
                  listeners: "deleteData",
                  confirm: "确定删除？",
                  disabled: (data) => data.status == "2",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            { type: "date", model: "date", span: 5 },
            {
              type: "input",
              model: "content",
              span: 3,
              placeholder: "请输入贴文内容",
            },
            {
              type: "input",
              model: "link",
              span: 3,
              placeholder: "请输入链接",
            },
            {
              type: "input",
              model: "pageName",
              span: 3,
              placeholder: "请输入专业名称",
            },
            {
              type: "input",
              model: "userName",
              span: 3,
              placeholder: "请输入创建者账号",
            },
            {
              type: "select",
              model: "sendType",
              span: 2,
              placeholder: "类型",
              setting: {
                multiple: true,
              },
              options: [
                { label: "链接", value: 1 },
                { label: "图片", value: 2 },
              ],
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "筛选",
                  style: "primary",
                  listeners: "searchData",
                },
                {
                  type: 2,
                  label: "批量删除",
                  style: "danger",
                  listeners: "deletePost",
                },
              ],
            },
          ],
        },
      },
      drawerData: {
        title: "留言信息",
        direction: "rtl",
        size: "45%",
        isLoading: false,
        data: {
          type: "table",
          headConfig: {
            select: false,
            selectProp: "id",
            key: "id",
            list: [
              { label: "昵称", prop: "name", width: "150" },
              { label: "留言信息", prop: "message" },
              { label: "评论时间", prop: "createdTime", width: "180" },
              {
                label: "操作",
                width: "150",
                operation: [
                  {
                    type: 1,
                    label: "删除",
                    style: "danger",
                    listeners: "callback1",
                    confirm: "确定删除？",
                  },
                ],
              },
            ],
          },
          content: [],
          callback1: async (data) => {
            this.drawerData.isLoading = true;
            let res = await deleteComments({
              pageId: data.pageId,
              commentId: data.id,
            });
            this.drawerData.isLoading = false;
            if (res === "ok") {
              this.$message({
                showClose: true,
                type: "success",
                message: "删除成功",
              });
              this.drawerData.data.content =
                this.drawerData.data.content.filter(
                  (item) => item.id != data.id
                );
            }
          },
          callback2() {},
        },
      },
    };
  },
  created() {},
  methods: {
    async requst(params) {
      if (this.$refs.table) {
        this.$refs.table.resetSort();
      }
      return await getSendPage({ ...params, ...{ type: 2 } });
    },
    async deleteDate(data) {
      this.isLoading = true;
      let res = await deleteSendHistory(new Array(1).fill(data.id));
      this.isLoading = false;
      if (res === "ok") {
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功",
        });
        this.getData();
      }
    },
    selectable(data) {
      return data.status !== "2";
    },
    deletePost(data) {
      if (this.selection.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择贴文",
          type: "error",
        });
        return;
      }
      this.$confirm("此操作将删除选择的贴文, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "删除中...";
            let res = await deleteSendHistory(this.selection);
            if (res === "ok") {
              done();
              this.getData();
            }
            instance.confirmButtonLoading = false;
          } else {
            done();
          }
        },
      }).then(() => {
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功!",
        });
      });
    },
    async showMessage(data) {
      this.isLoading = true;
      this.drawerData.data.content = [];
      let res = await getComments({
        pageId: data.pageId,
        pagePostId: data.sendId,
      });
      if (res && res.length) {
        this.drawerData.data.content = res.map((item) => {
          item.name = item.from ? item.from.name : "匿名用户";
          item.pageId = data.pageId;
          return item;
        });
      }
      this.isLoading = false;
      this.$refs.drawer.show();
    },
  },
};
</script>

<style></style>
